export default {
      id: "about-symbols-09-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-09",
      toString: function () {
        return this.url;
      }
    }